import { render } from "./RecentDocuments.vue?vue&type=template&id=2c7eac8c&scoped=true"
import script from "./RecentDocuments.vue?vue&type=script&lang=js"
export * from "./RecentDocuments.vue?vue&type=script&lang=js"

import "./RecentDocuments.vue?vue&type=style&index=0&id=2c7eac8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7eac8c"]])

export default __exports__